import xlsx from "json-as-xlsx";
import moment from "moment";
import React from "react";
import BarChartGraphic from "../../../../components/Graphics/Bar/BarChartGraphic";
import { Button, Col, Row } from "reactstrap";
import { ExchangeIcon } from "../../../../components/Icons/ExchangeIcon";
import ReactTooltip from "react-tooltip";
import { Select } from "../../../../components/Wrappers/SelectAll";
import { selectComponentStyles } from "../../../../services/utils/globalFunctions";
import { Bar } from "recharts";
import { Rectangle } from "@react-google-maps/api";
import {
  Card,
  CardContent,
  CardFooter,
  CardHeader,
} from "../../../../components/Cards/Card";
import DataTable from "react-data-table-component";

const ProductivityByAreasGraphics = ({ data, filters }) => {
  const [areasSummary, setAreasSummary] = React.useState([]);
  const [selectedGraphic, setSelectedGraphic] = React.useState({
    label: "Gráfico (App)",
    value: "app",
  });
  const [visualizationType, setVisualizationType] = React.useState("graphic");

  React.useEffect(() => {
    if (!data || data.length === 0) return;


    const areasProductivitySummary = {};

    data.forEach(({ territorializationName, productivityByPeriods }) => {
      const result = {
        territorializationName,
        appInstalledTraps: 0,
        typingInstalledTraps: 0,
        appReadedTraps: 0,
        typingReadedTraps: 0,
        appUninstalledTraps: 0,
        typingUninstalledTraps: 0,
        appUnableToReadTraps: 0,
        typingUnableToReadTraps: 0,
      };

      productivityByPeriods.forEach(({ app, typing }) => {
        result.appInstalledTraps += app.installed;
        result.typingInstalledTraps += typing.installed;
        result.appReadedTraps += app.readed;
        result.typingReadedTraps += typing.readed;
        result.appUninstalledTraps += app.uninstalled;
        result.typingUninstalledTraps += typing.uninstalled;
        result.appUnableToReadTraps += app.unableToRead;
        result.typingUnableToReadTraps += typing.unableToRead;
      });

      areasProductivitySummary[territorializationName] = result;
    });

    const areasSummary = Array.from(Object.values(areasProductivitySummary));

    setAreasSummary(areasSummary);
  }, [data]);

  const handleDownloadFile = () => {
    const xlsxFileSettings = {
      fileName: `produtividade_areas_VITEC_${moment().format(
        "DD/MM/YYYY HH:mm"
      )}`,
      extraLength: 3,
      writeMode: "writeFile",
      writeOptions: {},
      RTL: false,
    };

    xlsx(
      [
        {
          sheet: "Produtividade por áreas",
          columns: tableColumns.map(({ name, selector }) => ({
            label: name,
            value: selector,
          })),
          content: areasSummary,
        },
      ],
      xlsxFileSettings
    );
  };

  const tableColumns = [
    {
      name: "Área",
      selector: "territorializationName",
      sortable: true,
    },
    {
      name: "Instalações (Campo)",
      selector: "appInstalledTraps",
      sortable: true,
    },
    {
      name: "Manutenções (Campo)",
      selector: "appReadedTraps",
      sortable: true,
    },
    {
      name: "Desinstalações (Campo)",
      selector: "appUninstalledTraps",
      sortable: true,
    },
    {
      name: "Instalações (Web)",
      selector: "typingInstalledTraps",
      sortable: true,
    },
    {
      name: "Manutenções (Web)",
      selector: "typingReadedTraps",
      sortable: true,
    },
    {
      name: "Desinstalações (Web)",
      selector: "typingUninstalledTraps",
      sortable: true,
    },
  ];

  const graphicsOptions = [
    {
      label: "Gráfico (Campo)",
      value: "app",
    },
    {
      label: "Gráfico (Web)",
      value: "typing",
    },
  ];

  const beginDateFormated =
    filters &&
    filters.beginDate &&
    moment(filters.beginDate).format("DD/MM/YYYY");
  const finalDateFormated =
    filters && filters.endDate && moment(filters.endDate).format("DD/MM/YYYY");

  if (areasSummary.length === 0) return null;

  if (visualizationType === "graphic") {
    if (selectedGraphic.value === "app")
      return (
        <section className="mb-4">
          <BarChartGraphic
            headerText={
              <span>
                Produtividade por áreas (Campo) de {beginDateFormated} à{" "}
                {finalDateFormated}
              </span>
            }
            headerContent={
              <>
                <Button
                  onClick={() => setVisualizationType("table")}
                  color="primary"
                  data-tip
                  data-for="exchangeGraphicType1"
                  style={{ width: "55px", marginRight: "0px" }}
                >
                  <i>
                    <ExchangeIcon variant="white" />
                  </i>
                </Button>
                <ReactTooltip
                  id="exchangeGraphicType1"
                  type="info"
                  place="bottom"
                  effect="solid"
                >
                  Trocar visualização
                </ReactTooltip>

                <div style={{ width: "150px" }}>
                  <Select
                    styles={selectComponentStyles}
                    placeholder={"Selecione"}
                    isMulti={false}
                    blurInputOnSelect={false}
                    closeMenuOnSelect={false}
                    isClearable={false}
                    value={selectedGraphic}
                    options={graphicsOptions}
                    onChange={(e) => setSelectedGraphic(e)}
                  />
                </div>
              </>
            }
            bars={[
              <Bar
                dataKey="appInstalledTraps"
                fill="#8884d8"
                name={"Instalações"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="appReadedTraps"
                fill="#82ca9d"
                name={"Manutenções"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="appUninstalledTraps"
                fill="#4181f7"
                name={"Desinstalações"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="appUnableToReadTraps"
                fill="#fa4c35"
                name={"Não lidas"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
            ]}
            data={areasSummary.sort((a, b) => {
              return (
                b.appInstalledTraps +
                b.appReadedTraps +
                b.appUninstalledTraps +
                b.appUnableToReadTraps -
                (a.appInstalledTraps +
                  a.appReadedTraps +
                  a.appUninstalledTraps +
                  a.appUnableToReadTraps)
              );
            })}
            xAxisDataKey="territorializationName"
            hideDownloadButton={true}
          />
        </section>
      );

    if (selectedGraphic.value === "typing")
      return (
        <section className="mb-4">
          <BarChartGraphic
            headerText={
              <span>
                Produtividade por áreas (Web) de {beginDateFormated} à{" "}
                {finalDateFormated}
              </span>
            }
            headerContent={
              <>
                <Button
                  onClick={() => setVisualizationType("table")}
                  color="primary"
                  data-tip
                  data-for="exchangeGraphicType2"
                  style={{ width: "55px", marginRight: "0px" }}
                >
                  <ExchangeIcon variant="white" />
                </Button>
                <ReactTooltip
                  id="exchangeGraphicType2"
                  type="info"
                  place="bottom"
                  effect="solid"
                >
                  Trocar visualização
                </ReactTooltip>
                <div style={{ width: "150px" }}>
                  <Select
                    styles={selectComponentStyles}
                    placeholder={"Selecione"}
                    isMulti={false}
                    blurInputOnSelect={false}
                    closeMenuOnSelect={false}
                    isClearable={false}
                    value={selectedGraphic}
                    options={graphicsOptions}
                    onChange={(e) => setSelectedGraphic(e)}
                  />
                </div>
              </>
            }
            bars={[
              <Bar
                dataKey="typingInstalledTraps"
                fill="#8884d8"
                name={"Instalações"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="typingReadedTraps"
                fill="#82ca9d"
                name={"Manutenções"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="typingUninstalledTraps"
                fill="#4181f7"
                name={"Desinstalações"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
              <Bar
                dataKey="typingUnableToReadTraps"
                fill="#fa4c35"
                name={"Não lidas"}
                activeBar={<Rectangle fill="pink" stroke="blue" />}
              />,
            ]}
            data={areasSummary.sort((a, b) => {
              return (
                b.typingInstalledTraps +
                b.typingReadedTraps +
                b.typingUninstalledTraps +
                b.typingUnableToReadTraps -
                (a.typingInstalledTraps +
                  a.typingReadedTraps +
                  a.typingUninstalledTraps +
                  a.typingUnableToReadTraps)
              );
            })}
            xAxisDataKey="territorializationName"
            hideDownloadButton={true}
          />
        </section>
      );

    return null;
  }

  if (visualizationType === "table")
    return (
      <section className="mb-4">
        <Card>
          <CardHeader
            headerText={
              <span>
                Tabela de produtividade por áreas de {beginDateFormated} à{" "}
                {finalDateFormated}
              </span>
            }
            showExpandButton={false}
            showButtonsTooltips={true}
            showDownloadDataButton={false}
          >
            <Button
              onClick={() => handleDownloadFile()}
              color="primary"
              data-tip
              data-for="dataDownload"
              style={{ width: "55px", marginRight: "0px" }}
            >
              <i className="fa fa-download" />
            </Button>
            <ReactTooltip effect="solid" type="info" id="dataDownload">
              Baixar dados
            </ReactTooltip>
            <Button
              onClick={() => setVisualizationType("graphic")}
              color="primary"
              data-tip
              data-for="exchangeGraphicType3"
              style={{ width: "55px", marginRight: "0px" }}
            >
              <ExchangeIcon variant="white" />
            </Button>
            <ReactTooltip
              id="exchangeGraphicType3"
              type="info"
              place="bottom"
              effect="solid"
            >
              Trocar visualização
            </ReactTooltip>
          </CardHeader>
          <CardContent>
            <Row>
              <Col>
                <DataTable
                  noHeader
                  defaultSortField="name"
                  defaultSortAsc={true}
                  pagination
                  highlightOnHover
                  responsive
                  columns={tableColumns}
                  data={areasSummary}
                  noDataComponent={"Nenhum registro encontrado."}
                />
              </Col>
            </Row>
          </CardContent>
          <CardFooter>
            <div></div>
            <img
              style={{ maxWidth: "100px", opacity: 0.5 }}
              src="/static/media/vitec.9bd71d52.png"
              alt="Logo do Vitec"
            />
          </CardFooter>
        </Card>
      </section>
    );

  return null;
};

export default ProductivityByAreasGraphics;
